import React from 'react';

import {
  CheckmarkCircleIcon,
  PermissionsActionsIcon,
  RoleIcon,
} from 'components/Icons';
import { CheckPermissionsRequired } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/OnboardGcp/Help/CheckPermissionsRequired';
import { CreateServiceAccount } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/OnboardGcp/Help/CreateServiceAccount';
import { EnableGoogleApis } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/OnboardGcp/Help/EnableGoogleAPIs';
import { GetEmailIdOfServiceAccount } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/OnboardGcp/Help/GetEmailIdOfServiceAccount';
import { PermissionsForOnboarding } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/OnboardGcp/Help/PermissionsForOnboarding';
import { GCPOnboardingHelp } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/OnboardGcp/types';

export const gcpHelpHeaderMapping = (
  type: GCPOnboardingHelp,
  serviceAccountCommand: string,
  serviceAccountEmailID: string,
) => {
  switch (type) {
    case GCPOnboardingHelp.Permissions:
      return {
        header: 'Permissions required for Onboarding',
        content: <PermissionsForOnboarding />,
        icon: <PermissionsActionsIcon />,
      };
    case GCPOnboardingHelp.CheckPermissions:
      return {
        header: 'Check Your Permissions Required to Onboard Project',
        content: <CheckPermissionsRequired command={serviceAccountCommand} />,
        icon: <CheckmarkCircleIcon />,
      };
    case GCPOnboardingHelp.EnableGoogleAPIs:
      return {
        header: 'Enable Google APIs',
        content: <EnableGoogleApis />,
        icon: <CheckmarkCircleIcon />,
      };
    case GCPOnboardingHelp.CreateServiceAccount:
      return {
        header: 'Create Service Account for Ariksa',
        content: <CreateServiceAccount command={serviceAccountCommand} />,
        icon: <RoleIcon />,
      };
    case GCPOnboardingHelp.ServiceAccountEmailID:
      return {
        header: 'Get Email ID of Service Account',
        content: <GetEmailIdOfServiceAccount command={serviceAccountEmailID} />,
        icon: <RoleIcon />,
      };
  }
};
